import { render, staticRenderFns } from "./AppInputAvatar.vue?vue&type=template&id=0acf3471&scoped=true&"
import script from "./AppInputAvatar.vue?vue&type=script&lang=js&"
export * from "./AppInputAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AppInputAvatar.vue?vue&type=style&index=0&id=0acf3471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf3471",
  null
  
)

export default component.exports